import apiClient from "../index";

export const getStudentPerformance = async () => {
  try {
    const response = await apiClient.get("/api/performance/students");
    return response.data;
  } catch (error) {
    console.error("Error fetching student performance:", error);
    throw error;
  }
};

export const getFailingStudents = async () => {
  try {
    const response = await apiClient.get("/api/performance/failing-students");
    return response.data;
  } catch (error) {
    console.error("Error fetching failing students:", error);
    throw error;
  }
};
